export const config = { scrollColour: "#E7E7E7", fontSize: 12 };
